export const backendHost = 'https://all-cures.com:444/cures'
